import _Promise from "@babel/runtime-corejs2/core-js/promise";
import BotDetector from '../lib/bot-detector';
/**
 *  异步获取是否为机器人
 */

export var asyncBotDetector = function asyncBotDetector() {
  return new _Promise(function (resolve, reject) {
    BotDetector.init({
      tests: ['mousemove', 'touchstart', 'gesture', 'gyroscope', 'devicemotion', 'deviceorientation', 'MozOrientation', 'orientationchange'],
      timeout: 100,
      callback: function callback(result) {
        resolve(result);
      }
    });
  });
};